/* eslint-disable import/no-anonymous-default-export */
import { Form, Input, Table } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import { useEffect } from "react";
import DataFilter from "../common/components/DataFilter";
import DataTable from "../common/components/DataTable";
import EditableCell from "../common/components/EditableCell";
import MainLayout from "../common/components/MainLayout";
import useUnidadesProduccionAPI, { UnidadProduccion } from "./useUnidadesProduccionAPI";


export default () => {
    const api = useUnidadesProduccionAPI();
    const createPage = "/unidades-produccion/guardar"
    const editPage = "/unidades-produccion/guardar/{Id}"

    const [nombreFilterForm] = Form.useForm();
    const generateFilters = (filters:Record<string, FilterValue | null>) => {
        return [
            filters?.Nombre != null ?  `contains(Nombre,'${filters!.Nombre![0]}')` : "",
            
        ];
    }


    useEffect(()=>{
        
    },[]);

    return (
        <MainLayout >
            <DataTable<UnidadProduccion,UnidadProduccion>
            list={api.list}
            delete={api.delete}
            createAction={{
                label:"Agregar unidad de producción",
                path:createPage
            }}
            deleteMultipleAction
            defaultSortOrder={"Id asc"}
            selectionType='checkbox'
            title={"Unidades de producción"}
            generateFilters={generateFilters}
            editItemAction={editPage}
            deleteItemAction
            deleteItemActionConfirmMessage={(item) => `¿Eliminar a ${item.Nombre}?`}
            defaultPageSize={25}
            
            >

                <Table.Column<UnidadProduccion>
                    width={`5%`}
                    title="ID"
                    dataIndex={"Id"}
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend","descend","ascend"]}
                />

                <Table.Column<UnidadProduccion>
                    width={`85%`}
                    title="Nombre"
                    dataIndex={"Nombre"}
                    sorter
                    render={(val, record)=>
                        <EditableCell<Partial<UnidadProduccion>>
                            save={api.save}
                            id={record.Id}
                            render={(value)=>value.Nombre!}
                            formValue={{Nombre:val}}
                            formItem={<Form.Item style={{marginBottom:0}} name={"Nombre"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend","descend","ascend"]}
                    filterDropdown={(props)=>{
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                                <Form.Item name={"Nombre"} style={{marginBottom:10}}>
                                    <Input placeholder='Nombre...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                   }
                   
                />




            </DataTable>
        </MainLayout>
    );

};